<template>
  <header id="head_top" :class="{'credit-top': creditTop}">
    <div v-if='signinUp' class="head_sign">
      <!-- <template v-if="userInfo">
        <div class="user_avatar">
          <router-link tag="i" to="/user"></router-link>
        </div>
      </template>
      <template v-else>
        <div class="head_register" @click="showRegister">注册</div>
        <div class="head_login" @click="showLogin">登录</div>
      </template> -->
    </div>
    <div class="head_goback" v-if="goBack" @click="goBackFunc"><i class="icon-arrow_lift"></i></div>
    <div class="head_goback" v-if="goUser" @click="goBackFunc"><i class="icon-arrow_lift"></i></div>
    <!-- <div class="head_goback" v-if="closer" @click="closeRegister"><i class="icon-arrow_lift"></i></div>
    <div class="head_goback" v-if="tryPlay" @click="closeTry"><i class="icon-arrow_lift"></i></div> -->
    <div class="title_head" v-if="headTitle">{{headTitle}}</div>
    <slot name="special_content"></slot>
    <slot name="time-select"></slot>
    <!-- 用来v-show返回的 -->
    <slot name="private-return"></slot>
  </header>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: 'head',
    data () {
      return {
      }
    },
    props: ['signinUp', 'headTitle', 'goBack', 'goUser', 'creditTop'],
    computed: {
      ...mapState(['userInfo'])
    },
    created () {
    },
    mounted () {
    },
    methods: {
      showRegister () {
        // document.body.classList.add('noscroll')
        // document.getElementsByTagName('html')[0].classList.add('noscroll')
        this.$router.push('/register')
      },
      // closeRegister () {
      //   this.SHOW_RE_PAGE(false)
      // },
      showLogin () {
        this.$router.push('/login')
      },
      goBackFunc () {
        if (window.history.state === null) {
          this.$router.push('/')
        } else {
          this.$router.go(-1)
        }
      },
      goUserFunc() {
        this.$router.push('/user')
      }
      // closeLogin () {
      //   this.SHOW_LOGIN_PAGE(false)
      // },
      // closeTry () {
      //   this.SHOW_TRY_PAGE(false)
      // },
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~@/common/stylus/mixin";
  #head_top
    position fixed
    width 100%
    height 0.9rem
    left 0
    top 0
    z-index 100
    background-color $blue
    .head_sign
      .head_register, .head_login, .user_avatar
        position absolute
        top 50%
        transform translateY(-50%)
        color #fff
        font-size $font-size-m
      // .head_register, .head_login
      //   font-weight 700
      .user_avatar
        left 0.2rem
        & > i
          display inline-block
          background-repeat no-repeat
          width 0.35rem
          height 0.4rem
          background-size 0.35rem 0.4rem
          bg-image('user')
      .head_register
        left 0.2rem
      .head_login
        right 0.2rem
    .head_goback
      position absolute
      top 0
      // top 50%
      left 0
      height 0.9rem
      line-height 0.9rem
      padding-left 0.2rem
      width 0.4rem
      // transform translateY(-50%)
      color #fff
      font-size $font-size-m
    .title_head
      text-align center
      height 0.9rem
      line-height 0.9rem
      color #fff
      font-size $font-size-l
    &.credit-top
      background #ffd005
</style>



// WEBPACK FOOTER //
// src/components/common/header/head.vue